/**
 * Tag presentation for an API communication-log record's outcome.
 *
 * Consumers: `communicationColumns` (collapsed row) and `ApiExpandedContent`
 * (expanded body), which must agree on how a submit reads.
 *
 * `pending` is not a transient UI state: it is written before the POST and stays
 * on the row when the outcome was never observed, so it warns rather than
 * reassures. `duplicate` is Signify answering `EXISTING` — the order was already
 * placed and this call created nothing (SYD-2325).
 */

import type { ApiCommunicationOutcome } from '#types';
import type { CommunicationTag } from './communicationTags';

export const apiOutcomeTags: Record<ApiCommunicationOutcome, CommunicationTag> = {
  pending: {
    label: 'AWAITING RESPONSE',
    color: 'orange',
  },
  success: {
    label: 'SUCCESS',
    color: 'green',
  },
  duplicate: {
    label: 'ALREADY PLACED',
    color: 'gold',
  },
  error: {
    label: 'ERROR',
    color: 'red',
  },
};
